<common-main-layout [configLoaded]="configLoaded">
  <ng-template #topBar>
    <tc-main-top-bar>
      <div after-title class="after-title-container">
        <div class="after-title-separator"></div>
        <div class="workspace-container">
          <div class="workspace-name" *ngIf="selectedWorkspaceName">
            {{ selectedWorkspaceName }}
          </div>
          <div class="workspace-description" *ngIf="selectedWorkspaceDescription">
            {{ selectedWorkspaceDescription }}
          </div>
        </div>
      </div>
    </tc-main-top-bar>
  </ng-template>
  <ng-template #navBar>
    <wlm-nav-bar> </wlm-nav-bar>
  </ng-template>
</common-main-layout>
